import api from '@services/interceptor';
import { localStorageService } from '@stores/localStorage.service';
import { useAuthStore } from '@store/auth';
export class LoginService {
  constructor(){
    this.auth = useAuthStore() 
  }
  async tryLogin(){
    let access_token = localStorageService.get('access_token')
    if(access_token){
      this.initApi(access_token);
      
      if(await this.getMy(access_token))
        this.auth.isAuthenticated = true
        return true
    }
    return false
  }
  async getMy(access_token){
    try {
      const response = await api.get('/api/wp/my');
      if(response.status == 200){
        this.auth.setMy(response.data)
        return true
      }
    } catch (error) {
      console.log(error)
      throw this.handleError(error);
    }
    return false
  }

  async login(credentials) {
    try {
      const response = await api.post('/api/auth/login', credentials);
      if (response.data.accessToken) {
        localStorageService.set('access_token',response.data.accessToken);
        localStorageService.set('refresh_token',response.data.refreshToken);
        this.initApi(response.data.accessToken);
        if(await this.getMy(response.data.accessToken))
          this.auth.isAuthenticated = true
          return true
      }
      return response.data;
    } catch (error) {
      console.log(error)
      throw this.handleError(error);
    }
  }
  initApi(Token){
    api.defaults.headers.common['Authorization'] = `Bearer ${Token}`;
  }

  async refreshToken() {
    throw new Error('Не готово');
    /*
    try {
      const refreshToken = localStorageService.getRefreshToken();
      if (!refreshToken) throw new Error('No refresh token');
      const response = await api.post('/auth/refresh', {
        refresh_token: refreshToken
      });
      if (response.data.access_token) {
        localStorageService.setToken(response.data.access_token);
        api.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
      }
      return response.data;
    } catch (error) {
      this.logout();
      throw error;
    }*/
  }

  handleError(error) {
    const errors = {
      400: 'Некорректный запрос',
      401: 'Не авторизован',
      403: 'Доступ запрещен',
      404: 'Ресурс не найден',
      422: 'Ошибка валидации',
      429: 'Слишком много запросов',
      500: 'Внутренняя ошибка сервера'
    };

    const status = error.response?.status;
    const message = error.response?.data?.message || 
                   error.response?.data?.error ||
                   errors[status] || 
                   error.message ||
                   'Произошла ошибка';

    return {
      status,
      message,
      errors: error.response?.data?.errors || {},
      originalError: error
    };
  }
}